import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import Logo from "../../../assets/Atithiseva-Logo-Final-1024x298.png";
import { useNavigate } from "react-router-dom";
import "../../../styles/TopBar.css";
import { LOGIN } from "../Routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../ui/FormFields/Button";
import { logoutRequest } from "../../../redux/auth/actions/authActions";
import NotificationIcon from "./NotificationIcon";
import NotificationModal from "./NotificationModal";
import ApprovalStatusIcon from "./ApprovalStatusIcon";

const TopBar = ({
  isDrawerOpen,
  handleDrawerToggle,
  anchorElUser,
  handleOpenUserMenu,
  unAuth = false,
  handleCloseUserMenu,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isVerySmallScreen = useMediaQuery("(max-width:360px)");
  const handleLogout = () => {
    dispatch(logoutRequest());
    localStorage.clear();
    navigate(LOGIN);
  };

  const getUserDisplayName = () => {
    if (!user) return "";

    if (isVerySmallScreen) {
      return user.first_name;
    } else if (isXsScreen) {
      return `${user.first_name} ${user.last_name.charAt(0)}.`;
    }

    return `${user.first_name} ${user.last_name}`;
  };

  return (
    <>
      <AppBar position="fixed" className="topbar-appbar">
        <Toolbar className="topbar-toolbar">
          <Box className="topbar-logo-container">
            {user && !unAuth && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                className="topbar-menu-icon"
                size={isXsScreen ? "small" : "medium"}
              >
                <MenuIcon fontSize={isXsScreen ? "small" : "medium"} />
              </IconButton>
            )}

            {!isDrawerOpen && (
              <img src={Logo} alt="Admin Logo" className="topbar-logo" />
            )}
          </Box>

          {user && !unAuth && (
            <Box className="topbar-user-container">
              {/* {user?.role === "Admin" && <ApprovalStatusIcon />} */}
              {( (user?.role || "").toLowerCase() === "admin" || (user?.role || "").toLowerCase() === "staff") && (
                <NotificationIcon />
              )}

              <Tooltip title={`${user?.first_name} ${user?.last_name}`} arrow>
                <Box className="topbar-user-info" onClick={handleOpenUserMenu}>
                  <Typography variant="body2" className="topbar-user-name">
                    {getUserDisplayName()}
                  </Typography>
                </Box>
              </Tooltip>
            </Box>
          )}

          {unAuth && (
            <Box>
              <CustomButton
                variant="contained"
                className="orange-button"
                text={isXsScreen ? "Login" : "Back To Login"}
                onClick={() => {
                  handleLogout();
                }}
                type="button"
                size={isXsScreen ? "small" : "medium"}
              />
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <NotificationModal />
    </>
  );
};

export default TopBar;
